import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-application-view',
  templateUrl: './application-view.component.html',
  styleUrls: ['./application-view.component.css']
})
export class ApplicationViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
